(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ople-trust-guarantee"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.addEventListener('click', function(e) {
      var openBtn = e.target.closest('[data-ople-trust-open]');
      if (openBtn) {
        var id = openBtn.getAttribute('data-ople-trust-open');
        var modal = document.getElementById('ople-trust-modal-' + id);
        if (modal) {
          modal.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
        return;
      }
      var closeBtn = e.target.closest('[data-ople-trust-close]');
      if (closeBtn) {
        var id2 = closeBtn.getAttribute('data-ople-trust-close');
        var modal2 = document.getElementById('ople-trust-modal-' + id2);
        if (modal2) {
          modal2.classList.remove('is-open');
          document.body.style.overflow = '';
        }
        return;
      }
      if (e.target.matches('[data-ople-trust-modal]')) {
        e.target.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        var open = document.querySelector('[data-ople-trust-modal].is-open');
        if (open) {
          open.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
